var React = require('react');

function ResetInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M23 12C23 18.0751 18.0751 23 12 23C5.92487 23 1 18.0751 1 12H3C3 16.9706 7.02944 21 12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C8.87958 3 6.13007 4.58803 4.51555 7H8V9H3H1V7V2H3V5.67384C4.99073 2.8469 8.27969 1 12 1C18.0751 1 23 5.92487 23 12Z","fill":"#D1D3D9"}));
}

ResetInline.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","role":"img","aria-label":""};

module.exports = ResetInline;

ResetInline.default = ResetInline;
